import { CustomAccordion } from '@sravni/cosago-react-library/lib/components';
import cn from 'classnames';
import type { ComponentProps } from 'react';

import styles from './CustomAccordionItem.module.scss';

type Props = ComponentProps<typeof CustomAccordion.Item> & {
  iconSize?: 36 | 48;
};

// TODO убрать после обновления дизайн системы до 3 версии в @sravni/cosago-react-library
export const CustomAccordionItem: FC<Props> = ({ children, iconSize = 36, ...props }) => (
  <CustomAccordion.Item
    {...props}
    className={cn(styles.customAccordionItem, {
      [styles.customAccordionItemWithBigIcon]: iconSize === 48,
      [styles.customAccordionItemDisabled]: props.disabled,
    })}
  >
    {children}
  </CustomAccordion.Item>
);
